import { InviteDelegatePage } from '@features/stakeholders/components/InviteDelegatePage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/invite-delegate')({ component: InviteDelegatePage });
